const DEFAULT_API_BASE = "https://j2lgiph624.execute-api.us-east-1.amazonaws.com/dev";
const LOCAL_DEV_API_BASE = "/api";

function resolveApiBase() {
  if (process.env.REACT_APP_API_BASE) {
    return process.env.REACT_APP_API_BASE;
  }

  if (window.location.hostname === "localhost") {
    return LOCAL_DEV_API_BASE;
  }

  return DEFAULT_API_BASE;
}

export const API_BASE = resolveApiBase();

export function buildApiUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE}${normalizedPath}`;
}
